import ZoneMixin from '@/Mixins/BaseInformation/ZoneMixin';
export default {
  data() {
    return {
      selectedZones: [...(this.$route?.query?.zones?.split(',')?.map((id) => +id) || [])],
      selectedZonesOngoing: [],
      positionSidebar: false,
      showingStationsList: [],
    };
  },
  mixins: [ZoneMixin],
  methods: {
    toggleShowingStations: function () {
      const validStations = this.allStations?.filter(
        (station) => station.latitude && station.longitude,
      );
      if (this.showingStationsList?.length) this.showingStationsList = [];
      else this.showingStationsList = [...validStations];
    },
  },
  watch: {
    positionSidebar: function (currentVal) {
      if (currentVal && !this.allZones?.length) this.getAllZones();
    },
    selectedZones: function (currentVal) {
      if (currentVal?.length) {
        const zoneQuery = [...currentVal].join(',');
        this.$router.replace({
          query: {
            zones: zoneQuery,
          },
        });
      } else {
        const currentQuery = this.$route?.query;
        delete currentQuery?.zones;
        this.$router.push({
          query: { ...currentQuery },
        });
      }
    },
    selectedZonesOngoing: function (currentVal) {
      if (currentVal?.length) {
        const zoneQuery = currentVal.map(item => item.id).join(',');
        this.$router.replace({
          query: {
            ...this.$route.query,
            zones: zoneQuery,
          },
        });
      } else {
        const { zones, ...restQuery } = this.$route.query;
        console.log(zones);
        this.$router.replace({ query: restQuery });
      }
    }
  },
  computed: {
    filteredPositions: function () {
      if (this.$route.name == 'dispatchMap' || this.$route.name == 'followUpMap' || this.$route.name == 'admissionMap' || this.$route.name == 'eocMap') {
        if ([...this.selectedZones]?.length)
          return [...this.allPhonesPositions]?.filter(({ phone }) =>
            [...this.selectedZones].includes(phone?.zoneId),
          );
        return [...this.allPhonesPositions];
      } else if (this.$route.name == 'newMissionWithMap800') {
        if ([...this.selectedZonesOngoing]?.length) {
          return [...this.allPhonesPositions]?.filter(({ phone }) => {
            const myList = this.selectedZonesOngoing?.map(i => i?.id);
            return myList.includes(phone?.zoneId);
          });
        }
        return [...this.allPhonesPositions];
      }

    },
  },
};
